import ExceptionMap from "../exceptions/ExceptionMap";

const ApiService = require("../services/ApiService");
const NotificationService = require("../services/NotificationService");

const state = () => ({
    orderData: {},
    orderAccessKey: "",
    orderReturnItems: [],
    orderReturnNote: ""
});

const mutations =
    {
        setOrderReturnData(state, orderData)
        {
            orderData.order.orderItems = orderData.order.orderItems.filter(orderItem => orderItem.quantity !== 0);

            state.orderData = orderData;
        },

        setOrderAccessKey(state, orderAccessKey)
        {
            state.orderAccessKey = orderAccessKey;
        },

        updateOrderReturnItems(state, { quantity, orderItem, reasonId })
        {
            if (quantity <= orderItem.quantity)
            {
                const orderItemIndex = state.orderReturnItems.findIndex(entry => entry.orderItem.itemVariationId === orderItem.itemVariationId);

                if (quantity !== 0)
                {
                    const existingReasonId = orderItemIndex !== -1
                        ? state.orderReturnItems[orderItemIndex].reasonId || 0
                        : 0;

                    const item = { quantity, orderItem, reasonId: typeof reasonId !== "undefined" ? reasonId : existingReasonId };

                    if (orderItemIndex === -1)
                    {
                        state.orderReturnItems.push(item);
                    }
                    else
                    {
                        state.orderReturnItems.splice(orderItemIndex, 1);
                        state.orderReturnItems.splice(orderItemIndex, 0, item);
                    }
                }
                else
                {
                    state.orderReturnItems.splice(orderItemIndex, 1);
                }
            }
        },

        updateOrderReturnItemReasonId(state, { itemVariationId, reasonId })
        {
            const item = state.orderReturnItems.find(entry => entry.orderItem.itemVariationId === itemVariationId);

            if (item)
            {
                item.reasonId = reasonId;
            }
        },

        updateOrderReturnNote(state, orderReturnNote)
        {
            state.orderReturnNote = orderReturnNote;
        }
    };

const actions =
    {
        sendOrderReturn({ state })
        {
            return new Promise((resolve, reject) =>
            {
                if (state.orderReturnItems.length > 0)
                {
                    const variationIds = {};

                    for (const index in state.orderReturnItems)
                    {
                        variationIds[state.orderReturnItems[index].orderItem.itemVariationId] = {
                            quantity: state.orderReturnItems[index].quantity,
                            reasonId: state.orderReturnItems[index].reasonId || 0
                        };
                    }

                    ApiService.post("/" + App.language + "/order/return/", {
                        orderId: state.orderData.order.id,
                        orderAccessKey: state.orderAccessKey,
                        variationIds,
                        returnNote: state.orderReturnNote
                    })
                        .done(data =>
                        {
                            resolve(data);
                        })
                        .fail(error =>
                        {
                            if (error.data)
                            {
                                NotificationService.error(
                                    this.$translate(
                                        "Ceres::Template." + ExceptionMap.get(error.data.exceptionCode.toString()),
                                        error.data.placeholder
                                    )
                                ).closeAfter(5000);
                            }
                            reject(error);
                        });
                }
                else
                {
                    reject();
                }
            });
        }
    };

const getters =
    {
        getOrderItemImage: state => orderItemId => state.orderData.itemImages[orderItemId],

        getOrderItemURL: state => orderItemId => state.orderData.itemURLs[orderItemId],

        getOrderItemVariation: state => orderItemId => state.orderData.variations[orderItemId]
    };

export default
{
    state,
    mutations,
    actions,
    getters
};
